<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-right: 20px" class="new-col">
      <a-card :bordered="false">
        <div id="app">
          <div id="map" class="map">
            <!-- 右下角控制信息容器 -->
            <div class="map-controls-container">
              <!-- 缩放级别显示 -->
              <div class="zoom-level-display">{{ $t('缩放级别:') }} {{ zoomLevel }}</div>
            
              <!-- 比例尺容器 -->
              <div id="scale-line-container" class="scale-line-custom-container"></div>
              
              <!-- 坐标显示（可点击切换） -->
              <div class="coordinate-display" @click="toggleCoordinateProjection">
                X: {{ formattedCoordinate.x }} Y: {{ formattedCoordinate.y }}
              </div>
            </div>
          </div>
          <NodeDetailsModal ref="NodeDetailsModalRef" @ok="callback" />
          <PipelineDetailsModal ref="PipelineDetailsModalRef" @ok="callback" />
        </div>
      </a-card>
      <a-icon
        :type="collapsed ? 'caret-left' : 'caret-right'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
    </a-col>
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AddNodeAndLineIndex
            ref="AddNodeAndLineIndexRef"
            @changeType="changeType"
            @changeHandleType="changeHandleType"
            @changeCapture="changeCapture"
            @changeCaptureTolerance="changeCaptureTolerance"
            @changeMap="changeMapVector"
            @cancelDrawMap="cancelDrawMap"
            @changeSave="changeSave"
          />
        </a-card>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import { get as getProjection, fromLonLat, toLonLat } from 'ol/proj'
import { createLayerEm_topology_node_pipeline } from '../module/layers/Em_topology_node_pipeline.js'
import { createLayerEM_MAP_ALL_18 } from '../module/layers/EM_MAP_ALL_18_DARK.js'
import { createLayerTp_node } from '../module/layers/Tp_node.js'
import { createLayerTp_pipeline } from '../module/layers/Tp_pipeline.js'
import { createLayerTp_area } from '../module/layers/Tp_area.js'
import { createGetFeatureInfo } from '../module/comFunction/WmsGetFeatureInfo.js'
import { parseHexWKB, zoomToPoint, zoomToLine } from '../module/comFunction/ComFunction.js'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { vectorStyle } from '../module/style/VectorStyle.js'
import { Feature } from 'ol'
import NodeDetailsModal from './components/NodeDetailsModal.vue' //节点属性编辑
import PipelineDetailsModal from './components/PipelineDetailsModal.vue' //管道属性编辑
import Vue from 'vue'
import ScaleLine from 'ol/control/ScaleLine'
import { getPostGreSqlNodeInfoByCode, getPostGreSqlLineInfoByCode } from '../module/comFunction/ApiFunction.js'
import CONFIG from '../module/config/GIS_Config'
import { updateTopology } from '../module/config/GIS_Config'
import AddNodeAndLineIndex from './components/AddNodeAndLineIndex.vue'
import { Circle, Fill, Stroke, Style, RegularShape } from 'ol/style'
import { Draw, Modify, Snap } from 'ol/interaction'
import { getArea, getLength } from 'ol/sphere'
// 新增导入
import Point from 'ol/geom/Point'
import {
  createSnapVectorLayer,
  createSnapPointSource,
  createSnapLineSource,
  createSnapLineVertexSource,
} from '../module/layers/SnapVectorLayer'
import {
  checkSnapTarget,
  checkViewportChangeSignificance,
  extractVerticesFromLineFeature,
  loadFeaturesAsync,
} from '../module/comFunction/ComFunction'
// 使用防抖函数控制更新频率
import debounce from 'lodash/debounce'

export default {
  name: 'App',
  components: {
    NodeDetailsModal,
    PipelineDetailsModal,
    AddNodeAndLineIndex,
  },
  data() {
    return {
      map: {},
      tileLayer: {},
      baseLayer: {},
      nodeLayerNode: {},
      pipeLineLayer: {},
      areaLayer: {},
      highlightLayer: {}, // 高亮矢量图层
      tileSource: {},
      view: {},
      resolutions: [],
      matrixIds: [],
      projection: '',
      currentRow: {},
      disabled: true,
      visible: false,
      zoomLevel: 0, //
      topology: '', // 全局拓扑参数
      scaleDisplayInterval: null, // 比例尺更新定时器
      coordinateProjection: 'EPSG:3857', // 当前坐标系（3857或4326）
      currentCoordinate: null,
      snapInteraction: null, // 吸附交互
      snapInteraction: null,
      snapTolerance: 15, // 吸附容差（像素）
      snapPointLayer: null, // 吸附点数据层
      snapLineLayer: null, // 吸附线数据层
      snapVectorLayer: null, // 吸附可视化图层
      snapLineVertexSource: null, // 新增：线折点数据源
      // 矢量图层初次加载时的视图状态
      lastViewState: {
        zoom: null,
        center: null,
        resolution: null,
        timestamp: Date.now(),
      },
      // 新加变量
      collapsed: true,
      editMode: 'none',
      snapToggle: false,
      nodeVectorSource: new VectorSource(),
      pipeVectorSource: new VectorSource(),
      areaVectorSource: new VectorSource(),
      drawInteraction: null,
      modifyInteraction: null,
      snap: null,
      currentHandle: {},
      editMap: false,
      debouncedUpdateSnapSources: null, // 防抖
      lastPointerTime: 0,
      tempVectorLayers: null, // 临时矢量图层
    }
  },
  computed: {
    // 格式化坐标显示
    formattedCoordinate() {
      if (!this.currentCoordinate) {
        return { x: '--', y: '--' }
      }

      if (this.coordinateProjection === 'EPSG:3857') {
        // 3857坐标系显示，保留3位小数
        return {
          x: this.currentCoordinate.x.toFixed(3),
          y: this.currentCoordinate.y.toFixed(3),
        }
      } else {
        // 4326坐标系显示（经纬度），保留6位小数
        const lonLat = toLonLat([this.currentCoordinate.x, this.currentCoordinate.y])
        return {
          x: lonLat[0].toFixed(6),
          y: lonLat[1].toFixed(6),
        }
      }
    },
  },
  created() {
    let query = JSON.parse(this.$route.query.arg)
    if (query.id) {
      this.disabled = query.disabled
      this.currentRow = {
        project_code: query.projectCode,
        topology_code: query.code,
      }
    } else {
      this.disabled = true
      this.currentRow = {}
    }
  },
  mounted() {
    // 更新拓扑配置（从 localStorage 读取最新的拓扑数据）
    updateTopology()
    
    this.$nextTick(()=>{
      this.initMap()
      // 新增点击事件监听
      this.map.on('click', this.handleMapClick)
      // 添加高亮图层
      this.initHighlightLayer()
      this.map.addLayer(this.highlightLayer)
      // 添加定时器，用于更新图层参数
      this.setupScaleDisplay()
      // 添加鼠标位置监听器
      this.setupMousePositionDisplay()
      // 初始化吸附图层和功能
      this.initSnapping()
    })
  },
  beforeDestroy() {
    // 清除定时器
    if (this.scaleDisplayInterval) {
      clearInterval(this.scaleDisplayInterval)
    }
    
    // 清除所有交互和图层
    this.cancelDrawMap()
  },
  methods: {
    initMap() {
      // 1. 投影配置 编码
      this.projection = getProjection(CONFIG.PROJECTION)

      // 4. 瓦片图层配置
      // let tileLayer = new TileLayer({ source: wmtsSource })
      this.tileLayer = createLayerEm_topology_node_pipeline()
      // 底图
      this.baseLayer = createLayerEM_MAP_ALL_18()
      // 点 图层
      this.nodeLayerNode = createLayerTp_node()
      // 线图层
      this.pipeLineLayer = createLayerTp_pipeline()
      this.areaLayer = createLayerTp_area()
      this.tileSource = this.tileLayer.getSource()
      // 从 WMTS 图层元数据中获取范围（假设服务端提供）
      let wmtsLayerExtent = CONFIG.DEFAULT_EXTENT

      // 2. 动态计算中心点
      const center = [
        (wmtsLayerExtent[0] + wmtsLayerExtent[2]) / 2, // 经度平均值
        (wmtsLayerExtent[1] + wmtsLayerExtent[3]) / 2, // 纬度平均值
      ]

      // 3. 转换为投影坐标系
      const projectedCenter = fromLonLat(center)
      const projectedExtent = [
        ...fromLonLat([wmtsLayerExtent[0], wmtsLayerExtent[1]]),
        ...fromLonLat([wmtsLayerExtent[2], wmtsLayerExtent[3]]),
      ].flat()

      // 4. 创建视图
      this.view = new View({
        center: projectedCenter,
        zoom: 11,
        projection: this.projection,
        // extent: projectedExtent, // 动态设置视图范围
      })

      // 7. 创建地图实例
      this.map = new Map({
        target: 'map',
        layers: [this.baseLayer, this.pipeLineLayer, this.nodeLayerNode],
        view: this.view,
        // 添加比例尺控件
        controls: [
          // 其他控件...
          new ScaleLine({
            className: 'ol-scale-line', // 自定义类名，用于样式覆盖
            units: 'metric', // 公制单位（米、公里）
            bar: false, // 使用条形比例尺（横向线段）
            steps: 1, // 比例尺分段数，这里设置为4段（默认是4，也可以不设置）
            text: false, // 显示比例尺文本
            minWidth: 80, // 最小宽度（像素）
            target: document.getElementById('scale-line-container'),
          }),
        ],
      })
      // +++ 新增：使用fit方法设置初始范围 +++
      this.$nextTick(() => {
        this.map.getView().fit(projectedExtent, {
          padding: [20, 20, 20, 20], // 添加适当的内边距
          duration: 0, // 立即生效
        })
      })
    },
    // 初始化高亮图层
    initHighlightLayer() {
      this.highlightLayer = new VectorLayer({
        source: new VectorSource(),
        style: feature => vectorStyle(feature), // 使用函数样式
        zIndex: 9999, // 确保在最上层
      })
    },
    // 设置鼠标位置显示
    setupMousePositionDisplay() {
      this.mouseMoveListener = this.map.on('pointermove', event => {
        const coordinate = event.coordinate
        this.currentCoordinate = {
          x: coordinate[0],
          y: coordinate[1],
        }
      })
    },
    // 切换坐标系
    toggleCoordinateProjection() {
      this.coordinateProjection = this.coordinateProjection === 'EPSG:3857' ? 'EPSG:4326' : 'EPSG:3857'
    },
    // 点击事件 获取点 线 信息
    async handleMapClick(evt) {
      console.log('点击左键evt属性:', evt)
      const coordinate = evt.coordinate
      const view = this.map.getView()
      const resolution = view.getResolution()
      const projection = view.getProjection()

      try {
        const layers = [
          { layer: this.nodeLayerNode, name: 'tp_node_sql' },
          { layer: this.pipeLineLayer, name: 'tp_pipeline_sql' },
        ]

        const results = await Promise.all(
          layers.map(async layerInfo => {
            const info = await createGetFeatureInfo({
              map: this.map,
              coordinate,
              layer: layerInfo.layer,
              layerName: layerInfo.name,
              resolution,
              projection,
            })
            return { ...layerInfo, info }
          })
        )
        console.log('所有图层结果:', results)
        
        // 只在非编辑模式下处理点击
        if (!this.editMap) {
          if (results[0].info.features.length > 0) {
            var node = Object.assign({}, results[0].info.features[0].properties, { id: results[0].info.features[0].id })
            this.$refs.NodeDetailsModalRef.init(Object.assign({}, node, this.currentRow))
            this.$refs.NodeDetailsModalRef.disableSubmit = this.disabled
          } else if (results[1].info.features.length > 0) {
            var node = Object.assign({}, results[1].info.features[0].properties, { id: results[1].info.features[0].id })
            this.$refs.PipelineDetailsModalRef.init(Object.assign({}, node, this.currentRow))
            this.$refs.PipelineDetailsModalRef.disableSubmit = this.disabled
          }
        }
        
        // 处理所有图层的结果
        results.forEach(result => {
          if (result.info && result.info.features.length > 0) {
            console.log(`${result.name} 图层属性:`, result.info.features)
            result.info.features.forEach(feature => {
              console.log('详细属性:', feature.properties)
            })
          }
        })
      } catch (error) {
        console.error('WMS查询失败:', error)
      }
    },
    // 处理在管线上添加节点的点击事件
    async handleAddNodeOnPipelineClick(evt, clickedFeature) {
      if (!clickedFeature) {
        this.$message.warning(this.$t('未点击到管线，请重新点击管线'))
        return
      }

      const coordinate = evt.coordinate
      console.log('点击的管线要素:', clickedFeature)

      try {
        // 解析管线几何
        const lineGeometry = parseHexWKB(clickedFeature.properties.geometry, 'EPSG:3857', 'EPSG:3857')
        
        if (lineGeometry) {
          // 计算点击点到管线的最近点（投影点）
          const closestPoint = lineGeometry.getClosestPoint(coordinate)
          console.log('点击坐标:', coordinate)
          console.log('投影点坐标:', closestPoint)

          // 转换为经纬度（4326）用于显示和存储
          const lonLat = toLonLat(closestPoint)
          console.log('投影点经纬度:', lonLat)

          // 在投影点位置创建临时节点标记
          this.showTempNodeMarker(closestPoint)

          // 打开节点详情模态框，传入投影点坐标
          const nodeData = {
            project_code: this.currentRow.project_code || CONFIG.TopologyProjection,
            topology_code: this.currentRow.topology_code || CONFIG.TopologyCode,
            coordinate: closestPoint, // EPSG:3857 坐标
            longitude: lonLat[0], // 经度
            latitude: lonLat[1], // 纬度
            x: closestPoint[0], // X坐标（EPSG:3857）
            y: closestPoint[1], // Y坐标（EPSG:3857）
            pipelineId: clickedFeature.id, // 所属管线ID
            pipelineCode: clickedFeature.properties.code, // 管线编码
          }

          // 打开节点详情模态框
          this.$refs.NodeDetailsModalRef.init(nodeData)
          this.$refs.NodeDetailsModalRef.disableSubmit = false

          // 移除临时标记
          setTimeout(() => {
            this.hideTempNodeMarker()
          }, 3000)
        }
      } catch (error) {
        console.error('在管线上添加节点失败:', error)
        this.$message.error(this.$t('操作失败: ') + error.message)
      }
    },
    // 显示临时节点标记
    showTempNodeMarker(coordinate) {
      const highlightSource = this.highlightLayer.getSource()
      
      // 创建临时节点要素
      const tempFeature = new Feature({
        geometry: new Point(coordinate),
        isTemp: true, // 标记为临时要素
      })

      // 设置临时节点样式
      tempFeature.setStyle(new Style({
        image: new Circle({
          radius: 8,
          fill: new Fill({ color: 'rgba(255, 0, 0, 0.8)' }),
          stroke: new Stroke({ color: '#fff', width: 2 }),
        }),
      }))

      highlightSource.addFeature(tempFeature)
    },
    // 隐藏临时节点标记
    hideTempNodeMarker() {
      const highlightSource = this.highlightLayer.getSource()
      const features = highlightSource.getFeatures()
      
      // 移除所有临时要素
      features.forEach(feature => {
        if (feature.get('isTemp')) {
          highlightSource.removeFeature(feature)
        }
      })
    },
    async getNodeInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlNodeInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    async getLineInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlLineInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    parseAndHighLight(item) {
      if (item == null) return
      // 解析十六进制geometry坐标。
      const geometry = parseHexWKB(item.geometry, 'EPSG:3857', 'EPSG:3857')
      if (!geometry) return

      // 清除之前的高亮要素
      const highlightSource = this.highlightLayer.getSource()
      highlightSource.clear()

      // 创建新要素并添加到高亮图层
      const feature = new Feature({
        geometry: geometry,
        featureType: item.id.startsWith('line') ? 'line' : 'point', // 标识类型
      })
      highlightSource.addFeature(feature)
      return geometry
    },
    setupScaleDisplay() {
      // 初始化缩放层级
      this.updateZoomLevel()

      // 添加地图缩放监听
      this.map.getView().on('change:resolution', () => {
        this.updateZoomLevel()
      })
      // 定期更新图层参数
      this.scaleDisplayInterval = setInterval(() => {
        this.updateLayerParams()
      }, 500)
    },
    // +++ 新增：更新缩放层级 +++
    updateZoomLevel() {
      if (this.map && this.map.getView()) {
        const currentZoom = this.map.getView().getZoom()
        // 四舍五入到整数（如果需要小数可以去掉）
        this.zoomLevel = Math.round(currentZoom)
      }
    },
    // 更新所有图层的参数
    updateLayerParams() {
      // 更新拓扑参数（如果缓存有变化）
      // 更新所有图层的参数
      const layers = [this.nodeLayerNode, this.pipeLineLayer, this.areaLayer]

      layers.forEach(layer => {
        if (layer && layer.getSource()) {
          layer.getSource().updateParams({
            VIEWPARAMS:
              'projectCode:' +
              CONFIG.TopologyProjection +
              ';topologyCode:' +
              CONFIG.TopologyCode +
              ';zoomLevel:' +
              this.zoomLevel,
          })

          // 强制刷新图层（解决缓存问题）
          layer.getSource().refresh()
        }
      })
    },
    refreshPipelineLayer() {
      const source = this.pipeLineLayer.getSource()
      source.updateParams({
        STYLES: 'Dynamic_Pipeline_Style',
        t: Date.now(), // 防止缓存
      })
      this.$nextTick(() => {
        this.map.updateSize()
      })
    },
    callback(){},
    /* 新加功能方法 */
    // 选择类型<1:节点，2:管道，3:区域>
    changeType(val) {
      this.currentHandle = val
      if (val.handleType == 1) {
        if (val.type == 1) {
          this.editMode = 'addNode'
        } else if (val.type == 2) {
          this.editMode = 'addPipe'
        } else if (val.type == 3) {
          this.editMode = 'addArea'
        }
      } else if (val.handleType == 2) {
        if (val.type == 1) {
          this.editMode = 'editNode'
        } else if (val.type == 2) {
          this.editMode = 'editPipe'
        } else if (val.type == 3) {
          this.editMode = 'editArea'
        }
      } else if (val.handleType == 3) {
        this.editMode = 'delete'
      }
      this.changeMap()
    },
    // 操作类型<1:新增，2:修改，3:删除>
    changeHandleType(val) {
      this.currentHandle = val
      if (val.handleType == 1) {
        if (val.type == 1) {
          this.editMode = 'addNode'
        } else if (val.type == 2) {
          this.editMode = 'addPipe'
        } else if (val.type == 3) {
          this.editMode = 'addArea'
        }
      } else if (val.handleType == 2) {
        if (val.type == 1) {
          this.editMode = 'editNode'
        } else if (val.type == 2) {
          this.editMode = 'editPipe'
        } else if (val.type == 3) {
          this.editMode = 'editArea'
        }
      } else if (val.handleType == 3) {
        this.editMode = 'delete'
      }
      this.changeMap()
    },
    // 捕捉设置开关<true:开启，false:关闭>
    changeCapture(val) {
      this.currentHandle = val
      this.snapToggle = val.isCapture
    },
    // 捕捉容差<默认20>
    changeCaptureTolerance(val) {
      this.currentHandle = val
      // this.updateSnapTolerance(val.captureTolerance)
    },
    // 触发绘制
    changeMapVector(val) {
      this.currentHandle = val
      this.editMap = true
      if (val.handleType == 1) {
        if (val.type == 1) {
          this.editMode = 'addNode'
        } else if (val.type == 2) {
          this.editMode = 'addPipe'
        } else if (val.type == 3) {
          this.editMode = 'addArea'
        }
      } else if (val.handleType == 2) {
        if (val.type == 1) {
          this.editMode = 'editNode'
        } else if (val.type == 2) {
          this.editMode = 'editPipe'
        } else if (val.type == 3) {
          this.editMode = 'editArea'
        }
      } else if (val.handleType == 3) {
        this.editMode = 'delete'
      }
      this.snapToggle = val.isCapture
      // this.snapInteraction = val.captureTolerance
      this.changeMap()
    },
    // 取消绘制
    cancelDrawMap() {
      this.editMap = false
      
      // 清除绘制交互
      if (this.drawInteraction) {
        this.map.removeInteraction(this.drawInteraction)
        this.drawInteraction = null
      }
      
      // 清除修改交互
      if (this.modifyInteraction) {
        this.map.removeInteraction(this.modifyInteraction)
        this.modifyInteraction = null
      }
      
      // 清除吸附交互
      if (this.snapInteraction) {
        this.snapInteraction.setActive(false)
      }
      
      if (this.pipeSnapInteraction) {
        this.map.removeInteraction(this.pipeSnapInteraction)
        this.pipeSnapInteraction = null
      }
      
      // 清除矢量图层
      if (this.tempVectorLayers) {
        this.tempVectorLayers.forEach(layer => {
          this.map.removeLayer(layer)
        })
        this.tempVectorLayers = null
      }
      
      // 清除矢量数据源
      this.nodeVectorSource.clear()
      this.pipeVectorSource.clear()
      this.areaVectorSource.clear()
      
      // 重置编辑模式
      this.editMode = 'none'
    },
    // 保存绘制
    changeSave() {},
    //
    changeMap() {
      // 确保地图已经初始化
      if (!this.map || !this.map.getView()) {
        console.warn('地图未初始化，无法添加交互')
        return
      }

      // 创建节点矢量图层
      const nodeVectorLayer = new VectorLayer({
        source: this.nodeVectorSource,
        style: new Style({
          image: new RegularShape({
            points: 4,
            radius: 7,
            rotation: Math.PI / 4,
            fill: new Fill({ color: 'red' }),
            stroke: new Stroke({ color: 'black', width: 1 }),
          }),
        }),
      })
      // 创建管道矢量图层
      const pipeVectorLayer = new VectorLayer({
        source: this.pipeVectorSource,
        style: new Style({
          fill: new Fill({ color: 'rgba(1, 210, 241, 0.2)' }),
          stroke: new Stroke({
            color: 'blue',
            width: 2,
          }),
        }),
      })
      // 创建区域矢量图层
      const areaVectorLayer = new VectorLayer({
        source: this.areaVectorSource,
        style: new Style({
          fill: new Fill({ color: 'rgba(255, 255, 255, 0.4)' }),
          stroke: new Stroke({
            radius: 7,
            color: '#ffcc33',
            width: 2,
            fill: '#ffcc33',
          }),
        }),
      })

      // 将矢量图层添加到地图中
      this.map.addLayer(nodeVectorLayer)
      this.map.addLayer(pipeVectorLayer)
      this.map.addLayer(areaVectorLayer)

      // 保存矢量图层引用，方便后续清理
      this.tempVectorLayers = [nodeVectorLayer, pipeVectorLayer, areaVectorLayer]

      this.initInteractions()
    },
    initInteractions() {
      // 修改交互，用于编辑节点和管线

      this.modifyInteraction = new Modify({
        source: this.nodeVectorSource, // 注意：这里需要同时修改两个source，可以后面再调整

        // 或者我们可以分别创建两个Modify，一个给节点，一个给管线
      })

      // 再添加一个捕捉管线的交互

      const pipeSnap = new Snap({
        source: this.pipeVectorSource, // 捕捉管线（线的顶点）
        // tolerance: this.snapTolerance,
      })

      this.map.addInteraction(pipeSnap)

      // 存储pipeSnap以便后续更新容差

      // 先不激活

      this.map.addInteraction(this.modifyInteraction)

      this.map.addInteraction(this.snapInteraction)

      this.modifyInteraction.setActive(false)

      this.snapInteraction.setActive(false)

      pipeSnap.setActive(false)

      // 将pipeSnap也存储起来

      this.pipeSnapInteraction = pipeSnap

      this.changeMode()
    },
    changeMode() {
      // 清除当前的绘制交互

      if (this.drawInteraction) {
        this.map.removeInteraction(this.drawInteraction)

        this.drawInteraction = null
      }

      // 根据当前模式设置交互

      switch (this.editMode) {
        case 'none':
          this.modifyInteraction.setActive(false)

          this.snapInteraction.setActive(false)

          this.pipeSnapInteraction.setActive(false)

          break

        case 'addNode':
          // 不激活 Modify，让它通过点击事件处理
          this.modifyInteraction.setActive(false)
          
          // 激活捕捉（用于吸附到现有节点和管线）
          this.snapInteraction.setActive(true)
          this.pipeSnapInteraction.setActive(true)

          // 创建绘制节点的交互
          this.drawInteraction = new Draw({
            source: this.nodeVectorSource,
            type: 'Point',
          })

          // 监听绘制开始事件，检测是否点击了管线
          this.drawInteraction.on('drawstart', async (event) => {
            const coordinate = event.coordinate
            const view = this.map.getView()
            const resolution = view.getResolution()
            const projection = view.getProjection()

            try {
              // 查询管线图层
              const pipelineInfo = await createGetFeatureInfo({
                map: this.map,
                coordinate,
                layer: this.pipeLineLayer,
                layerName: 'tp_pipeline_sql',
                resolution,
                projection,
              })

              // 如果点击了管线
              if (pipelineInfo && pipelineInfo.features && pipelineInfo.features.length > 0) {
                // 取消当前绘制
                this.drawInteraction.abortDrawing()
                
                // 在管线上添加节点
                await this.handleAddNodeOnPipelineClick(
                  { coordinate },
                  pipelineInfo.features[0]
                )
              }
            } catch (error) {
              console.error('检测管线失败:', error)
            }
          })

          this.drawInteraction.on('drawend', event => {
            const geometry = event.feature.getGeometry()
            const coordinate = geometry.getCoordinates()
            
            // 转换为经纬度（4326）
            const lonLat = toLonLat(coordinate)
            
            // 打开节点详情模态框
            const nodeData = {
              project_code: this.currentRow.project_code || CONFIG.TopologyProjection,
              topology_code: this.currentRow.topology_code || CONFIG.TopologyCode,
              coordinate: coordinate, // EPSG:3857 坐标
              longitude: lonLat[0], // 经度
              latitude: lonLat[1], // 纬度
              x: coordinate[0], // X坐标（EPSG:3857）
              y: coordinate[1], // Y坐标（EPSG:3857）
            }
            
            this.$refs.NodeDetailsModalRef.init(nodeData)
            this.$refs.NodeDetailsModalRef.disableSubmit = false
            
            // 清除绘制的临时要素
            this.nodeVectorSource.clear()
          })

          this.map.addInteraction(this.drawInteraction)

          break

        case 'addPipe':
          this.modifyInteraction.setActive(false)

          this.snapInteraction.setActive(true)

          this.pipeSnapInteraction.setActive(true)

          this.drawInteraction = new Draw({
            source: this.pipeVectorSource,
            type: 'LineString',
            // 可以设置条件，比如至少两个点
          })

          this.drawInteraction.on('drawend', event => {
            const geometry = event.feature.getGeometry()
            let pointArr = geometry.getCoordinates()
            // 绘制结束打开添加管线的模态框
            // this.$refs.PipelineDetailsModalRef.init({})
            // this.$refs.PipelineDetailsModalRef.disableSubmit = false
          })

          this.map.addInteraction(this.drawInteraction)

          break

        case 'addArea':
          this.modifyInteraction.setActive(false)

          this.snapInteraction.setActive(true)

          this.pipeSnapInteraction.setActive(true)

          this.drawInteraction = new Draw({
            source: this.areaVectorSource,
            type: 'Polygon',
          })

          this.drawInteraction.on('drawend', event => {
            const geometry = event.feature.getGeometry()
            let pointArr = geometry.getCoordinates()
            // 绘制结束打开添加区域的模态框
          })

          this.map.addInteraction(this.drawInteraction)

          break

        case 'edit':
          // 编辑模式下，激活修改和捕捉

          this.modifyInteraction.setActive(true)

          this.snapInteraction.setActive(true)

          this.pipeSnapInteraction.setActive(true)

          // 注意：这里我们可能需要将两个矢量源都添加到Modify中，但上面的Modify只设置了一个源

          // 我们可以创建另一个Modify用于管线，或者用一个Modify同时处理两个源（需要合并源？）

          // 这里简单处理：重新创建一个Modify，同时包含两个源

          // 先移除原来的Modify

          this.map.removeInteraction(this.modifyInteraction)

          // 创建一个新的Modify，同时修改节点和管线

          this.modifyInteraction = new Modify({
            sources: [this.nodeVectorSource, this.pipeVectorSource, this.areaVectorSource],
          })

          this.map.addInteraction(this.modifyInteraction)

          break

        case 'editNode': {
          // 编辑模式下，激活修改和捕捉
          this.modifyInteraction.setActive(true)
          this.snapInteraction.setActive(true)

          this.map.removeInteraction(this.modifyInteraction)

          // 创建一个新的Modify，同时修改节点和管线

          // 创建修改交互
          this.modifyInteraction = new Modify({
            sources: this.nodeVectorSource,
            condition: event => {
              const feature = this.map.forEachFeatureAtPixel(event.pixel, f => (f.get('type') === 'node' ? f : null))
              return !!feature
            },
            style: new Style({
              image: new RegularShape({
                points: 4,
                radius: 8,
                fill: new Fill({ color: 'gold' }),
                stroke: new Stroke({ color: 'black', width: 1 }),
              }),
            }),
          })

          // 添加管线修改（支持顶点编辑）
          const pipeModify = new Modify({
            source: this.pipeVectorSource,
            style: new Style({
              image: new Circle({
                radius: 6,
                fill: new Fill({ color: 'lime' }),
                stroke: new Stroke({ color: 'black', width: 1 })
              })
            }),
            insertVertexCondition: () => true // 允许添加顶点
          });

          const handleModifyEnd = event => {
            event.features.forEach(feature => {
              if (feature.get('status') !== 'new') {
                feature.set('status', 'modified')
              }

              // 如果是管线，更新长度
              if (feature.get('type') === 'pipe') {
                const line = feature.getGeometry()
                const length = getLength(line)
                feature.set('length', length.toFixed(2))
              }
            })
          }
          this.modifyInteraction.on('modifyend', handleModifyEnd)
          pipeModify.on('modifyend', handleModifyEnd);

          this.map.addInteraction(this.modifyInteraction)
          this.map.addInteraction(pipeModify)
          this.map.addInteraction(this.snapInteraction)

          break;
        }
      }
    },
    // 初始化吸附功能
    initSnapping() {
      // 创建吸附可视化图层
      this.snapVectorLayer = createSnapVectorLayer()
      this.map.addLayer(this.snapVectorLayer)

      this.snapPointSource = createSnapPointSource()
      this.snapLineSource = createSnapLineSource()
      this.snapLineVertexSource = createSnapLineVertexSource()

      // 创建 Snap 交互（用于节点吸附）
      this.snapInteraction = new Snap({
        source: this.snapPointSource,
        edge: true,
        vertex: true,
        pixelTolerance: 10,
      })

      // 在线要素源加载时提取折点（新增）
      this.snapLineSource.on('addfeature', event => {
        extractVerticesFromLineFeature(event.feature, this.snapLineVertexSource)
      })

      // 初始加载当前视图内的要素
      const view = this.map.getView()
      const extent = view.calculateExtent(this.map.getSize())
      // this.snapPointSource.loadFeatures(extent, view.getResolution(), view.getProjection())
      // this.snapLineSource.loadFeatures(extent, view.getResolution(), view.getProjection())
      // this.snapLineVertexSource.loadFeatures(extent, view.getResolution(), view.getProjection())

      
      // 初始化防抖函数
      this.debouncedUpdateSnapSources = debounce(this.updateSnapSources, 500)

      // 添加吸附逻辑的事件监听
      this.map.on('pointermove', this.handlePointerMove)

      // 监听视图变化事件，重新加载要素
      this.map.getView().on('change:center', this.debouncedUpdateSnapSources)
      this.map.getView().on('change:resolution', this.debouncedUpdateSnapSources)
      // 延迟初始加载
      setTimeout(() => {
        this.updateSnapSources()
      }, 1000)
    },
    
    // 更新吸附源数据
    // 优化后的吸附数据源更新方法
    updateSnapSources() {
      const view = this.map.getView()
      const extent = view.calculateExtent(this.map.getSize())
      const resolution = view.getResolution()
      const projection = view.getProjection()
      const zoomLevel = this.zoomLevel
      // const shouldUpdate = this.checkViewportChangeSignificance()
      const shouldUpdate = checkViewportChangeSignificance(this.map, this.lastViewState)

      if (!shouldUpdate) {
        return
      }

      // 并行加载点线数据
      Promise.all([
        loadFeaturesAsync(
          CONFIG,
          this.snapPointSource,
          'tp_node_sql',
          extent,
          resolution,
          projection,
          CONFIG.TopologyProjection,
          CONFIG.TopologyCode,
          zoomLevel
        ),

        loadFeaturesAsync(
          CONFIG,
          this.snapLineSource,
          'tp_pipeline_sql',
          extent,
          resolution,
          projection,
          CONFIG.TopologyProjection,
          CONFIG.TopologyCode,
          zoomLevel
        )
      ]).finally(() => {
        // 视图变化不显著时仅刷新折点
        const vertexOnly = !shouldUpdate
        this.updateSnapVertices(vertexOnly)
      })
    },
    
    // 更新折点数据（支持增量更新）
    updateSnapVertices(fullRefresh = false) {
      if (fullRefresh) {
        this.snapLineVertexSource.clear()
      }

      // 获取当前视图内新加载的线要素
      const newFeatures = this.snapLineSource.getFeatures().filter(feature => !feature.get('vertexProcessed'))

      // 处理新线要素的折点
      newFeatures.forEach(feature => {
        extractVerticesFromLineFeature(feature, this.snapLineVertexSource)
        feature.set('vertexProcessed', true)
      })
    },
    // 处理鼠标移动吸附（修改）
    handlePointerMove(event) {
      const now = Date.now()
      if (now - this.lastPointerTime < 50) { // 20 FPS限制
        return
      }
      this.lastPointerTime = now
      if (!event.dragging) {
        // 清除所有吸附可视化
        this.snapVectorLayer.getSource().clear()

        // 按优先级查找吸附点：点要素 > 线折点 > 线要素
        let snapPoint = this.findPointSnap(event.pixel)
        let snapVertex = snapPoint ? null : this.findLineVertexSnap(event.pixel)
        let snapLine = snapPoint || snapVertex ? null : this.findLineSnap(event.pixel)

        // 处理结果
        if (snapPoint) {
          this.showSnapPoint(snapPoint)
          this.currentCoordinate = { x: snapPoint.vertex[0], y: snapPoint.vertex[1] }
        } else if (snapVertex) {
          this.showSnapVertex(snapVertex)
          this.currentCoordinate = { x: snapVertex.vertex[0], y: snapVertex.vertex[1] }
        } else if (snapLine) {
          this.showSnapPoint(snapLine)
          this.currentCoordinate = { x: snapLine.vertex[0], y: snapLine.vertex[1] }
        } else {
          this.currentCoordinate = {
            x: event.coordinate[0],
            y: event.coordinate[1],
          }
        }
      }
    },

    // 吸附目标检查（使用公共方法）
    findPointSnap(pixel) {
      return checkSnapTarget(this.map, this.snapPointSource, pixel, this.snapTolerance)
    },

    findLineVertexSnap(pixel) {
      return checkSnapTarget(this.map, this.snapLineVertexSource, pixel, this.snapTolerance)
    },

    findLineSnap(pixel) {
      return checkSnapTarget(this.map, this.snapLineSource, pixel, this.snapTolerance)
    },

    // 显示点吸附（新增）
    showSnapPoint(result) {
      const feature = new Feature(new Point(result.vertex))
      this.snapVectorLayer.getSource().addFeature(feature)
    },

    // 显示折点吸附（新增）
    showSnapVertex(result) {
      const feature = new Feature(new Point(result.vertex))
      this.snapVectorLayer.getSource().addFeature(feature)
    },
    // 设置容差
    setSnapTolerance(tolerance) {
      this.snapTolerance = tolerance
      // 无需设置交互容差，因为我们是自定义实现
    },

  },
}
</script>

<style>
#map {
  width: 100%;
  height: 80vh;
}
/* +++ 新增比例尺样式 +++ */
/* 自定义比例尺控件样式 */
.ol-scale-line {
  background: rgba(255, 255, 255, 0.5); /* 半透明白色背景 */
  border-radius: 4px;
  bottom: 8px;
  left: 8px; /* 默认在左下角，可以调整位置 */
  padding: 2px;
  position: absolute;
}

.ol-scale-line-inner {
  border: 1px solid #333;
  border-top: none;
  color: #333;
  font-size: 10px;
  text-align: center;
  margin: 1px;
  will-change: contents, width;
  transition: all 0.25s;
  /* 禁止用户选择文本 */
  user-select: none;
  pointer-events: none;
}

/* 如果想要将比例尺放在右下角，可以这样调整 */
.ol-scale-line {
  left: auto;
  right: 8px;
}

/* 右下角控制信息容器 */
.map-controls-container {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1000;
  gap: 5px;
}

/* 缩放级别显示 */
.zoom-level-display {
  background: rgba(255, 255, 255, 0.5);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  font-weight: normal;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  user-select: none;
  margin-bottom: 13px;
}

/* 坐标显示 - 可点击切换 */
.coordinate-display {
  background: rgba(255, 255, 255, 0.5);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
  user-select: none;

  /* 等宽字体确保对齐 */
  font-family: 'Courier New', Courier, monospace;

  /* 在可点击元素上添加悬停效果 */
  &:hover {
    background: rgba(245, 245, 245, 0.95);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  }

  /* 添加坐标系提示 */
  .projection-hint {
    font-size: 10px;
    color: #666;
    margin-top: 2px;
    font-weight: normal;
    font-style: italic;
  }
}

/* 自定义比例尺容器 */
.scale-line-custom-container {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.scale-line-custom-container .ol-scale-line {
  margin-bottom: 24px;
}

/* 比例尺样式 */
.scale-line-custom .ol-scale-line {
  position: static;
  background: none;
}

/* 比例尺文本 */
.scale-line-custom .ol-scale-text {
  font-size: 11px;
  font-weight: bold;
  color: #333;
  text-shadow: 0 0 2px white;
  text-align: center;
  margin-top: 2px;
}

/* 比例尺条 */
.scale-line-custom .ol-scale-bar {
  background: #333;
  height: 3px;
  margin-top: 2px;
}
/* 吸附指示器样式 */
.ol-snap .ol-overlay-container {
  z-index: 10000 !important;
}
</style>
<style scoped>
.area-collapsed {
  position: absolute;
  right: -10px;
  left: auto;
  top: 20%;
  color: #333;
  font-size: 40px;
}
</style>
